import React, { Component } from 'react';
import './ClientTrackingTool.css';

class ClientTrackingTool extends Component {
  	constructor(props) {
		super(props);
    }

  	render() {
        if (this.props.client && this.props.client.client_name) {
            return (
                <div className="showtix-client-tracking-tool">
                    <div>Client name: {this.props.client.client_name}</div>
                    <div>Client id: {this.props.client.id}</div>
                    {!isNaN(this.props.current_client_id) &&
                        <div>Current Client id: {this.props.current_client_id}</div>
                    }
                    {(this.props.routeProps && this.props.routeProps.match.params.id) &&
                        <div>URL Client id: {this.props.routeProps && this.props.routeProps.match.params.id}</div>
                    }
                    {localStorage.getItem('lsid') &&
                        <div>Local storage lsid: {localStorage.getItem('lsid')}</div>
                    }
                  </div>
            );
        } else {
            return false;
        }
  	}
}

export default ClientTrackingTool;



// WEBPACK FOOTER //
// ./src/components/Common/ClientTrackingTool/ClientTrackingTool.js